import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/destructuring-assignment */
import React from 'react';
;
export class ErrorBoundary extends React.Component {
    state = {
        error: undefined,
    };
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, errorInfo) {
        console.warn(error, errorInfo);
        return;
    }
    resetErrorBoundary = () => {
        this.setState({ error: undefined });
    };
    render() {
        const { FallbackComponent } = this.props;
        if (this.state.error) {
            return (_jsx(FallbackComponent, { error: this.state.error, resetErrorBoundary: this.resetErrorBoundary }));
        }
        return this.props.children;
    }
}
//# sourceMappingURL=index.js.map